export const SEARCH = "SEARCH/search";
export const CHANGE_QUERY = "SEARCH/changeQuery";
export const SET_LOADING = "SEARCH/setLoading";
export const RESET = "SEARCH/reset";
